import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { postCamion as addCamion } from "../helpers/rutaCamiones";
import "../css/addclienteform.css";
import "animate.css";

const estadoInicial = {
  camion: "",
  patente: "",

  tipoUnidad: "CAMION",
  marca: "",
  modelo: "",
  anio: "",

  titular: "",
  cuitTitular: "",
  perteneceDanlu: "",

  chasis: "",
  motor: "",
  tipoCombustible: "NO_INFORMADO",
  capacidadCarga: "",
  categoriaInterna: "",

  telepaseActivo: false,
  telepaseNroTag: "",
  telepaseNroContratoCuenta: "",
  telepaseEstado: "NO_APLICA",
  telepaseObservaciones: "",

  telepeajePlusActivo: false,
  telepeajePlusNroTag: "",
  telepeajePlusNroContratoCuenta: "",
  telepeajePlusEstado: "NO_APLICA",
  telepeajePlusObservaciones: "",

  observaciones: "",
};

const AddCamionForm = ({ setShow }) => {
  const [formValues, setFormValues] = useState(
    estadoInicial
  );

  const [guardando, setGuardando] =
    useState(false);

  const [showSuccess, setShowSuccess] =
    useState(false);

  const [mensajeError, setMensajeError] =
    useState("");

  /* ======================================================
     CAMBIOS GENERALES
  ====================================================== */

  const handleChange = (e) => {
    const { name, value, type, checked } =
      e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : value,
    }));
  };

  /* ======================================================
     ARMAR PAYLOAD
  ====================================================== */

  const armarPayload = () => {
    return {
      camion:
        formValues.camion.trim(),

      patente:
        formValues.patente
          .trim()
          .toUpperCase()
          .replace(/\s+/g, ""),

      tipoUnidad:
        formValues.tipoUnidad,

      marca:
        formValues.marca.trim(),

      modelo:
        formValues.modelo.trim(),

      anio:
        formValues.anio
          ? Number(formValues.anio)
          : null,

      titular:
        formValues.titular.trim(),

      cuitTitular:
        formValues.cuitTitular.trim(),

      perteneceDanlu:
        formValues.perteneceDanlu === ""
          ? null
          : formValues.perteneceDanlu ===
            "SI",

      chasis:
        formValues.chasis.trim(),

      motor:
        formValues.motor.trim(),

      tipoCombustible:
        formValues.tipoCombustible,

      capacidadCarga:
        formValues.capacidadCarga
          ? Number(
              formValues.capacidadCarga
            )
          : 0,

      categoriaInterna:
        formValues.categoriaInterna.trim(),

      peajes: {
        telepase: {
          activo:
            formValues.telepaseActivo,

          nroTag:
            formValues.telepaseNroTag.trim(),

          nroContratoCuenta:
            formValues.telepaseNroContratoCuenta.trim(),

          estadoDispositivo:
            formValues.telepaseActivo
              ? formValues.telepaseEstado === "NO_APLICA"
                ? "ACTIVO"
                : formValues.telepaseEstado
              : "NO_APLICA",

          observaciones:
            formValues.telepaseObservaciones.trim(),
        },

        telepeajePlus: {
          activo:
            formValues.telepeajePlusActivo,

          nroTag:
            formValues.telepeajePlusNroTag.trim(),

          nroContratoCuenta:
            formValues.telepeajePlusNroContratoCuenta.trim(),

          estadoDispositivo:
            formValues.telepeajePlusActivo
              ? formValues.telepeajePlusEstado === "NO_APLICA"
                ? "ACTIVO"
                : formValues.telepeajePlusEstado
              : "NO_APLICA",

          observaciones:
            formValues.telepeajePlusObservaciones.trim(),
        },
      },

      observaciones:
        formValues.observaciones.trim(),
    };
  };

  /* ======================================================
     GUARDAR
  ====================================================== */

  const handleSubmit = async (e) => {
    e.preventDefault();

    setMensajeError("");

    if (!formValues.camion.trim()) {
      setMensajeError(
        "Debe ingresar una descripción del vehículo."
      );
      return;
    }

    if (!formValues.patente.trim()) {
      setMensajeError(
        "Debe ingresar la patente."
      );
      return;
    }

    try {
      setGuardando(true);

      const resp =
        await addCamion(
          armarPayload()
        );

      if (!resp?.ok) {
        setMensajeError(
          typeof resp?.error === "string"
            ? resp.error
            : resp?.error?.message ||
                "No se pudo crear el vehículo."
        );

        return;
      }

      console.log(
        "✅ Vehículo creado:",
        resp
      );

      setShowSuccess(true);

      setTimeout(() => {
        setShowSuccess(false);
        setFormValues(estadoInicial);

        if (setShow) {
          setShow(false);
        }
      }, 1200);
    } catch (error) {
      console.error(error);

      setMensajeError(
        "Error al crear el vehículo."
      );
    } finally {
      setGuardando(false);
    }
  };

  return (
    <>
      <div className="container-fluid">
        <div
          className="card shadow-sm"
          style={{
            borderRadius: 10,
          }}
        >
          <div className="card-header bg-white">
            <h5 className="mb-0">
              Nuevo vehículo
            </h5>

            <small className="text-muted">
              Datos generales de la unidad,
              titularidad y sistemas de peaje
            </small>
          </div>

          <div className="card-body">
            <form onSubmit={handleSubmit}>

              {/* =================================================
                  DATOS GENERALES
              ================================================= */}

              <h6 className="mb-3">
                1. Datos generales
              </h6>

              <div className="form-row">
                <div className="form-group col-md-3">
                  <label>
                    Patente *
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="patente"
                    required
                    maxLength="10"
                    value={
                      formValues.patente
                    }
                    onChange={
                      handleChange
                    }
                    style={{
                      textTransform:
                        "uppercase",
                    }}
                  />
                </div>

                <div className="form-group col-md-3">
                  <label>
                    Tipo de unidad *
                  </label>

                  <select
                    className="form-control"
                    name="tipoUnidad"
                    value={
                      formValues.tipoUnidad
                    }
                    onChange={
                      handleChange
                    }
                  >
                    <option value="CAMION">
                      Camión
                    </option>

                    <option value="CAMIONETA">
                      Camioneta
                    </option>

                    <option value="AUTO">
                      Auto
                    </option>

                    <option value="ACOPLADO">
                      Acoplado
                    </option>

                    <option value="SEMIRREMOLQUE">
                      Semirremolque
                    </option>

                    <option value="UTILITARIO">
                      Utilitario
                    </option>

                    <option value="OTRO">
                      Otro
                    </option>
                  </select>
                </div>

                <div className="form-group col-md-6">
                  <label>
                    Descripción *
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="camion"
                    required
                    maxLength="80"
                    placeholder="Ej.: Scania R450"
                    value={
                      formValues.camion
                    }
                    onChange={
                      handleChange
                    }
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col-md-4">
                  <label>Marca</label>

                  <input
                    type="text"
                    className="form-control"
                    name="marca"
                    value={
                      formValues.marca
                    }
                    onChange={
                      handleChange
                    }
                  />
                </div>

                <div className="form-group col-md-4">
                  <label>Modelo</label>

                  <input
                    type="text"
                    className="form-control"
                    name="modelo"
                    value={
                      formValues.modelo
                    }
                    onChange={
                      handleChange
                    }
                  />
                </div>

                <div className="form-group col-md-4">
                  <label>Año</label>

                  <input
                    type="number"
                    className="form-control"
                    name="anio"
                    min="1900"
                    max="2100"
                    value={
                      formValues.anio
                    }
                    onChange={
                      handleChange
                    }
                  />
                </div>
              </div>

              <hr />

              {/* =================================================
                  TITULARIDAD
              ================================================= */}

              <h6 className="mb-3">
                2. Titularidad
              </h6>

              <div className="form-row">
                <div className="form-group col-md-5">
                  <label>Titular</label>

                  <input
                    type="text"
                    className="form-control"
                    name="titular"
                    placeholder="Ej.: DANLU SRL"
                    value={
                      formValues.titular
                    }
                    onChange={
                      handleChange
                    }
                  />
                </div>

                <div className="form-group col-md-4">
                  <label>
                    CUIT del titular
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="cuitTitular"
                    placeholder="30-00000000-0"
                    value={
                      formValues.cuitTitular
                    }
                    onChange={
                      handleChange
                    }
                  />
                </div>

                <div className="form-group col-md-3">
                  <label>
                    ¿Pertenece a DANLU?
                  </label>

                  <select
                    className="form-control"
                    name="perteneceDanlu"
                    value={
                      formValues.perteneceDanlu
                    }
                    onChange={
                      handleChange
                    }
                  >
                    <option value="">
                      Sin informar
                    </option>

                    <option value="SI">
                      Sí
                    </option>

                    <option value="NO">
                      No
                    </option>
                  </select>
                </div>
              </div>

              <hr />

              {/* =================================================
                  DATOS TÉCNICOS
              ================================================= */}

              <h6 className="mb-3">
                3. Datos técnicos
              </h6>

              <div className="form-row">
                <div className="form-group col-md-4">
                  <label>
                    N.º de chasis
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="chasis"
                    value={
                      formValues.chasis
                    }
                    onChange={
                      handleChange
                    }
                  />
                </div>

                <div className="form-group col-md-4">
                  <label>
                    N.º de motor
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="motor"
                    value={
                      formValues.motor
                    }
                    onChange={
                      handleChange
                    }
                  />
                </div>

                <div className="form-group col-md-4">
                  <label>
                    Combustible
                  </label>

                  <select
                    className="form-control"
                    name="tipoCombustible"
                    value={
                      formValues.tipoCombustible
                    }
                    onChange={
                      handleChange
                    }
                  >
                    <option value="NO_INFORMADO">
                      No informado
                    </option>

                    <option value="DIESEL">
                      Diésel
                    </option>

                    <option value="NAFTA">
                      Nafta
                    </option>

                    <option value="GNC">
                      GNC
                    </option>

                    <option value="ELECTRICO">
                      Eléctrico
                    </option>

                    <option value="HIBRIDO">
                      Híbrido
                    </option>

                    <option value="NO_APLICA">
                      No aplica
                    </option>

                    <option value="OTRO">
                      Otro
                    </option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group col-md-4">
                  <label>
                    Capacidad de carga (kg)
                  </label>

                  <input
                    type="number"
                    className="form-control"
                    name="capacidadCarga"
                    min="0"
                    value={
                      formValues.capacidadCarga
                    }
                    onChange={
                      handleChange
                    }
                  />
                </div>

                <div className="form-group col-md-4">
                  <label>
                    Categoría interna
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="categoriaInterna"
                    placeholder="Ej.: Pesado"
                    value={
                      formValues.categoriaInterna
                    }
                    onChange={
                      handleChange
                    }
                  />
                </div>
              </div>

              <hr />

              {/* =================================================
                  TELEPASE
              ================================================= */}

              <h6 className="mb-3">
                4. Adhesión a peajes
              </h6>

              <div className="card mb-3">
                <div className="card-body">
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="telepaseActivo"
                      name="telepaseActivo"
                      checked={
                        formValues.telepaseActivo
                      }
                      onChange={
                        handleChange
                      }
                    />

                    <label
                      className="form-check-label font-weight-bold"
                      htmlFor="telepaseActivo"
                    >
                      TELEPASE
                    </label>
                  </div>

                  {formValues.telepaseActivo && (
                    <div className="form-row">
                      <div className="form-group col-md-3">
                        <label>
                          N.º Tag / oblea
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          name="telepaseNroTag"
                          value={
                            formValues.telepaseNroTag
                          }
                          onChange={
                            handleChange
                          }
                        />
                      </div>

                      <div className="form-group col-md-3">
                        <label>
                          Contrato / cuenta
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          name="telepaseNroContratoCuenta"
                          value={
                            formValues.telepaseNroContratoCuenta
                          }
                          onChange={
                            handleChange
                          }
                        />
                      </div>

                      <div className="form-group col-md-3">
                        <label>
                          Estado
                        </label>

                        <select
                          className="form-control"
                          name="telepaseEstado"
                          value={
                            formValues.telepaseEstado
                          }
                          onChange={
                            handleChange
                          }
                        >
                          <option value="ACTIVO">
                            Activo
                          </option>

                          <option value="INACTIVO">
                            Inactivo
                          </option>

                          <option value="EN_TRAMITE">
                            En trámite
                          </option>

                          <option value="SIN_DISPOSITIVO">
                            Sin dispositivo
                          </option>
                        </select>
                      </div>

                      <div className="form-group col-md-3">
                        <label>
                          Observación
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          name="telepaseObservaciones"
                          value={
                            formValues.telepaseObservaciones
                          }
                          onChange={
                            handleChange
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* =================================================
                  TELEPEAJE PLUS
              ================================================= */}

              <div className="card mb-3">
                <div className="card-body">
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="telepeajePlusActivo"
                      name="telepeajePlusActivo"
                      checked={
                        formValues.telepeajePlusActivo
                      }
                      onChange={
                        handleChange
                      }
                    />

                    <label
                      className="form-check-label font-weight-bold"
                      htmlFor="telepeajePlusActivo"
                    >
                      TELEPEAJE PLUS
                    </label>
                  </div>

                  {formValues.telepeajePlusActivo && (
                    <div className="form-row">
                      <div className="form-group col-md-3">
                        <label>
                          N.º Tag / oblea
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          name="telepeajePlusNroTag"
                          value={
                            formValues.telepeajePlusNroTag
                          }
                          onChange={
                            handleChange
                          }
                        />
                      </div>

                      <div className="form-group col-md-3">
                        <label>
                          Contrato / cuenta
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          name="telepeajePlusNroContratoCuenta"
                          value={
                            formValues.telepeajePlusNroContratoCuenta
                          }
                          onChange={
                            handleChange
                          }
                        />
                      </div>

                      <div className="form-group col-md-3">
                        <label>
                          Estado
                        </label>

                        <select
                          className="form-control"
                          name="telepeajePlusEstado"
                          value={
                            formValues.telepeajePlusEstado
                          }
                          onChange={
                            handleChange
                          }
                        >
                          <option value="ACTIVO">
                            Activo
                          </option>

                          <option value="INACTIVO">
                            Inactivo
                          </option>

                          <option value="EN_TRAMITE">
                            En trámite
                          </option>

                          <option value="SIN_DISPOSITIVO">
                            Sin dispositivo
                          </option>
                        </select>
                      </div>

                      <div className="form-group col-md-3">
                        <label>
                          Observación
                        </label>

                        <input
                          type="text"
                          className="form-control"
                          name="telepeajePlusObservaciones"
                          value={
                            formValues.telepeajePlusObservaciones
                          }
                          onChange={
                            handleChange
                          }
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <hr />

              <div className="form-group">
                <label>
                  Observaciones generales
                </label>

                <textarea
                  className="form-control"
                  name="observaciones"
                  rows="2"
                  value={
                    formValues.observaciones
                  }
                  onChange={
                    handleChange
                  }
                />
              </div>

              {mensajeError && (
                <div className="alert alert-danger">
                  {mensajeError}
                </div>
              )}

              <div className="text-right">
                <button
                  type="submit"
                  className="btn btn-success px-4"
                  disabled={guardando}
                >
                  {guardando
                    ? "Guardando..."
                    : "Guardar vehículo"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <Modal
        show={showSuccess}
        centered
        backdrop="static"
        keyboard={false}
        dialogClassName="animate__animated animate__fadeInDown"
      >
        <Modal.Body className="text-center">
          <div
            style={{
              fontSize: "3rem",
            }}
          >
            ✅
          </div>

          <h5 className="mt-2">
            Vehículo registrado correctamente
          </h5>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddCamionForm;